import { PropsWithChildren } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

export const DndLayoutComponentsProvider = (props: PropsWithChildren) => {
  const { children } = props;
  return <DndProvider backend={HTML5Backend}>{children}</DndProvider>;
};
